/* eslint-disable no-restricted-imports */ // allow to import @/infrastructure, @/usecases
import { createGraphqlClient } from './infrastructure'

export const useCreateSystem = () => {
  const backendUri = `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/graphql`

  const graphqlClient = createGraphqlClient({ backendUri })

  return {
    graphqlClient
  }
}
